import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Upload } from './../../../components/includes/upload';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn, RichTextMarkdown } from './../../../components/includes/ui';
import { BlogService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {}

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (values.featured === '-1') {
    errors.featured = VALIDATION.required;
  }

  if (values.comments === '-1') {
    errors.comments = VALIDATION.required;
  }

  if (values.category === '-1') {
    errors.category = VALIDATION.required;
  }

  if (!values.meta_description) {
    errors.meta_description = VALIDATION.required;
  } else if (values.meta_description.length > 255) {
    errors.meta_description = 'El tamaño máximo es de 255 caracteres.';
  }

  if (!values.preview) {
    errors.preview = VALIDATION.required;
  } else if (values.preview.length > 255) {
    errors.preview = 'El tamaño máximo es de 255 caracteres.';
  }

  if (!values.title) {
    errors.title = VALIDATION.required;
  } else if (values.title.length > 255) {
    errors.title = 'El tamaño máximo es de 255 caracteres.';
  }

  return errors

};

class BlogCreate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      sending: false,
      upload: false,
      categories: []
    };
  }

  componentDidMount(){
    this._Categories();
  }

  /*
  ** @Service
  ** @Description: Categories
  */

  _Categories = () => {

    BlogService.categories().then((response) => {

      this.setState({ categories: response.categories || [] });

    }).catch((error) => {


    });

  }

  /*
  ** @Service
  ** @Description: New
  */

  _Create = (values) => {

    BlogService.create(values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/blog');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el blog fue creado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  handleSubmitForm = (values) => {
    this._Create(values);
  }

  /*
  ** @Service
  ** @Description: Attachments
  */

  onUploadImagenPreview = (file) => {
    this.props.dispatch(change('BlogCreate', 'image_preview', file.attachment[0] ));
  }

  onUploadImagenDetail = (file) => {
    this.props.dispatch(change('BlogCreate', 'image_detail', file.attachment[0] ));
  }

  render() {

    const { sending, categories } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Blog"/>
        <BreadcrumbItem to='/blog'>Blog</BreadcrumbItem>
        <BreadcrumbItem to='/blog/create'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

              <Ttolbar title="Creación de nota"/>

              <FormContent enabledActions>

                <Grid container spacing={24}>

                  <Grid item lg={8} md={8} sm={12} xs={12}>
                    <Field
                        name="title"
                        component={ InputTextField }
                        label="Título"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Field
                        name="category"
                        component={ SelectField }
                        label="Categoría" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          {categories.map((category) => {
                            return (
                              <OptionField key={category._id} value={category._id}>{category.name}</OptionField>
                            )
                          })}
                    </Field>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Field
                        name="preview"
                        component={ InputTextField }
                        label="Descripción"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Field
                        name="featured"
                        component={ SelectField }
                        label="Destacada" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="true" value="true">Activo</OptionField>
                          <OptionField key="false" value="false">Bloqueado</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Field
                        name="status"
                        component={ SelectField }
                        label="Estado" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="true" value="true">Activo</OptionField>
                          <OptionField key="false" value="false">Bloqueado</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Field
                        name="comments"
                        component={ SelectField }
                        label="Comentarios" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="true" value="true">Activo</OptionField>
                          <OptionField key="false" value="false">Bloqueado</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Field
                        name="meta_title"
                        component={ InputTextField }
                        label="Meta title"
                        type="text"
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Field
                        name="meta_keywords"
                        component={ InputTextField }
                        label="Meta keywords"
                        type="text"
                    />
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Field
                        name="meta_description"
                        component={ InputTextField }
                        label="Meta description"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Field
                        name="image_preview"
                        type="hidden"
                        component={ InputTextField }
                    />
                    <Upload
                      button="Subir imagen (Destacada)"
                      onSuccess={ this.onUploadImagenPreview.bind(this) }
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Field
                        name="image_detail"
                        type="hidden"
                        component={ InputTextField }
                    />
                    <Upload
                      button="Subir imagen (Listado+Detalle)"
                      onSuccess={ this.onUploadImagenDetail.bind(this) }
                    />
                  </Grid>

                  <Grid item lg={12} md={12} sm={12}>
                    <Field
                        name="description"
                        component={ RichTextMarkdown }
                        label="Descipción"
                        type="text"
                        required={true}
                    />
                  </Grid>

                </Grid>

              </FormContent>

              <FormActions>
                <Grid container>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons>
                      <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/blog">
                        Volver
                      </Btn>
                    </Buttons>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons align="right">
                      <Btn aria-label="Guardar nota" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                        Guardar nota
                      </Btn>
                    </Buttons>
                  </Grid>
                </Grid>
              </FormActions>

            </form>

          </Main>

        </Content>
      </Section>
    )
  }
}

BlogCreate = reduxForm({
  form: 'BlogCreate',
  validate,
  initialValues: {
    category: '-1',
    featured: '-1',
    status: '-1',
    comments: '-1',
    link_target: '_self'
  }
})(BlogCreate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogCreate);
